import { IPrintCheckHistoryParams, IUpdatePrintCheckBody } from 'features/report/services/types/check';
import fetch from 'services/request';
import { IApiGetConsentFormReportParam, IApiPrintMultipleCheckItem, IApiSendReportEmailsCpaParam, IStaffAdjustmentSaleBody, IStaffAdjustmentSaleParams } from './types/api';
import { IEditReviewReportPayload, IParamsReportSalaryStaff, IParamsReviewReport } from './types/review';

// const baseURL = 'api/v1/:merchant_code/demoData';

export const getDemoData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { data: [] } });
    }, 1000);
  });
  // return fetch({
  //   method: 'get',
  //   url: `${baseURL}/getDemoData`,
  //   params: params as any
  // });
};

export const getPrintSummarySalon = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/print-report/summary-salon',
    params,
  });
};

const getPrintSummaryPaymentTypes = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/print-report/summary-payment-type',
    params,
  });
};

export const getSummaryTicket = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/summary-ticket',
    params,
  });
};

export const getSummarySalon = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: 'api/v1/report/summary-salon',
    params,
  });
};

export const getSummaryServiceCategory = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: 'api/v1/report/summary-service-category',
    params,
  });
};

export const getTopRankingService = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/top-ranking-service',
    params,
  });
};

export const getSummarySalaryStaff = (params: {
  startDate: string;
  endDate: string;
  salaryType?: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/summary-salary-staff',
    params,
  });
};

export const getSummaryDashboardSalaryStaff = (params: {
  startDate: string;
  endDate: string;
  salaryType?: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/summary-dashboard-salary-staff',
    params,
  });
};

export const getSalaryStaffDetail = (params: {
  startDate: string;
  endDate: string;
  staffId: string;
  paymentType?: string;
}) => {
  return fetch({
    method: 'get',
    url: `/api/v1/report/salary-staff-detail/${params.staffId}`,
    params: {
      startDate: params.startDate,
      endDate: params.endDate,
      paymentType: params?.paymentType || undefined,
    },
  });
};

export const getPrintSummaryServiceCategory = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/print-report/summary-service-category',
    params,
  });
};

export const getDashboardTimeClockReport = (params: {
  startDate: string;
  endDate: string;
  staffId?: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/dashboard-time-clock-report',
    params,
  });
};

export const getTimeClockReportHistory = (params: {
  startDate: string;
  endDate: string;
  staffId?: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/time-clock-report-history',
    params,
  });
};

export const getPrintSalaryStaffDetailOneDay = (params: {
  startDate: string;
  endDate: string;
  staffId: string;
}) => {
  return fetch({
    method: 'get',
    url: `/api/v1/print-report/salary-staff-detail-one-day/${params.staffId}`,
    params,
  });
};

export const getPrintSalaryStaffDetailRangeDate = (params: {
  startDate: string;
  endDate: string;
  staffId: string;
}) => {
  return fetch({
    method: 'get',
    url: `/api/v1/print-report/salary-staff-detail-date-range/${params.staffId}`,
    params,
  });
};

export const getPrintSalarySummaryStaffOneDay = (params: {
  startDate: string;
  endDate: string;
  salaryType?: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/print-report/salary-summary-staff-one-day',
    params,
  });
};

export const getPrintSalarySummaryStaffRangeDate = (params: {
  startDate: string;
  endDate: string;
  salaryType?: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/print-report/salary-summary-staff-range-date',
    params,
  });
};
const getPrintSalarySummaryStaffRangeDateV2 = (body: {
  startDate: string;
  endDate: string;
  salaryType?: string;
  staffIds?: string[];
}) => {
  return fetch({
    method: 'post',
    url: '/api/v1/print-report/salary-summary-staff-range-date-v2',
    body: {
      salaryType: 'ALL',
      startDate: body.startDate,
      endDate: body.endDate,
      staffIds: body.staffIds
    },
  });
};

const getReviewReport = (params: IParamsReviewReport) => {
  const transformedParams = { ...params };
  if (transformedParams.stars && Array.isArray(transformedParams.stars)) {
    const stars = transformedParams.stars;
    delete transformedParams.stars;

    const searchParams = new URLSearchParams();
    Object.entries(transformedParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, value.toString());
      }
    });
    stars.forEach(star => searchParams.append('stars', star.toString()));

    return fetch({
      method: 'get',
      url: `/api/v1/review?${searchParams.toString()}`,
    });
  }

  return fetch({
    method: 'get',
    url: '/api/v1/review',
    params: transformedParams,
  });
};

const editReviewReviewReport = (body: IEditReviewReportPayload) => {
  return fetch({
    method: 'post',
    url: '/api/v1/review',
    body,
    autoToast: true,
  });
};

const updateReviewNote = (body: { reviewId: string; reason: string }) => {
  return fetch({
    method: 'post',
    url: '/api/v1/review/update-note',
    body,
    autoToast: true,
  });
};

const getReviewReportSummary = (params: IParamsReviewReport) => {
  const transformedParams = { ...params };
  if (transformedParams.stars && Array.isArray(transformedParams.stars)) {
    const stars = transformedParams.stars;
    delete transformedParams.stars;

    const searchParams = new URLSearchParams();
    Object.entries(transformedParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        searchParams.append(key, value.toString());
      }
    });
    stars.forEach(star => searchParams.append('stars', star.toString()));

    return fetch({
      method: 'get',
      url: `/api/v1/review/summary-rating?${searchParams.toString()}`,
    });
  }

  return fetch({
    method: 'get',
    url: '/api/v1/review/summary-rating',
    params: transformedParams,
  });
};

const getCheckNum = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/shop/check-number',
  });
};

const getSignature = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/shop/signature',
  });
};

const savePrintCheckHistory = (staffId: string, checkNo: string, additionalData?: Record<string, any>) => {
  return fetch({
    method: 'post',
    url: '/api/v1/shop/print-check-history',
    body: { staffId, checkNo, ...additionalData || {} },
  });
};

const saveCheckSignature = (signature: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/shop/save-signature',
    body: {
      signature,
    },
  });
};

export const getPrintTimeClockRange = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/print-report/time-clock-range',
    params,
  });
};

export const getSummaryAppointmentChart = (params: {
  type: string;
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/summary-appointment-chart',
    params,
  });
};

export const getSummarySaleChart = (params: {
  type: string;
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/summary-sale-chart',
    params,
  });
};

export const getSummaryCategoryChart = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/summary-chart-item-type',
    params,
  });
};

const getReportSalaryStaff = (params: IParamsReportSalaryStaff) => fetch({
  method: 'get',
  url: '/api/v1/report/salary-staff',
  params,
});
const getReportSalaryStaffV2 = (body: IParamsReportSalaryStaff) => fetch({
  method: 'post',
  url: '/api/v1/report/salary-staff-v2',
  body,
});

export const getSummaryPaymentTypeChart = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/summary-chart-payment-type',
    params,
  });
};

const getConsentFormReport = (params: IApiGetConsentFormReportParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/history-consent-form',
    params,
  });
};

const getProductReport = (params: {
  startDate: string;
  endDate: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/category-by-products',
    params,
  });
};

export const getPrintCashDepositByDate = (params: {
  startDate: string;
  endDate: string;
  staffId?: string;
}) => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/print-cash-deposit-by-date',
    params,
  });
};

export const getPrintCashDepositById = (id: string) => {
  return fetch({
    method: 'get',
    url: `api/v1/shop/print-cash-deposit/${id}`,
  });
};

const printMultipleCheck = (body: IApiPrintMultipleCheckItem[]) => {
  return fetch({
    method: 'post',
    url: '/api/v1/shop/multiple-print-check-history',
    body,
  });
};

const sendReportEmailsCpa = (body: IApiSendReportEmailsCpaParam) => {
  return fetch({
    method: 'post',
    url: '/api/v1/report/send-mail-cpa',
    body,
  });
};

const getCashDepositReport = (params: {
  startDate: string;
  endDate: string;
  staffId?: string;
}) => {
  return fetch({
    method: 'get',
    url: '/api/v1/shop/report-cash-deposit',
    params,
  });
};

const deleteCashDeposit = (cashDepositId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/shop/cash-deposit/${cashDepositId}`,
  });
};

const getReportSalaryStaffYearly = (year: number, staffIds?: string[]) => {
  return fetch({
    method: 'post',
    url: '/api/v1/report/yearly-payroll',
    body: { year, staffIds, salaryType: null },
  });
};

// /api/v1/report/print-discount
const getHomeReportDiscount = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/print-discount',
  });
};

const getPrintCheckHistory = (params: IPrintCheckHistoryParams) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/print-check',
    params,
  });
};

const deletePrintCheckHistory = (id: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/report/delete-history-check/${id}`,
  });
};

const updatePrintCheckHistory = (body: IUpdatePrintCheckBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/report/update-history-check',
    body,
  });
};

const createSaleAdjustment = (body: IStaffAdjustmentSaleBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/report/staff-adjustment-sale',
    body,
  });
};

const getListSaleAdjustment = (params: IStaffAdjustmentSaleParams) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/staff-adjustment-sale',
    params,
  });
};

const deleteSaleAdjustment = (id: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/report/staff-adjustment-sale/${id}`,
  });
};


const reportApis = {
  getDemoData,
  getPrintSummarySalon,
  getSummarySalon,
  getSummaryServiceCategory,
  getSummaryTicket,
  getTopRankingService,
  getSummarySalaryStaff,
  getSummaryDashboardSalaryStaff,
  getSalaryStaffDetail,
  getPrintSummaryServiceCategory,
  getDashboardTimeClockReport,
  getTimeClockReportHistory,
  getPrintSalaryStaffDetailOneDay,
  getPrintSalaryStaffDetailRangeDate,
  getPrintSalarySummaryStaffOneDay,
  getPrintSalarySummaryStaffRangeDate,
  getPrintSalarySummaryStaffRangeDateV2,
  getReviewReport,
  editReviewReviewReport,
  updateReviewNote,
  getReviewReportSummary,
  getPrintSummaryPaymentTypes,
  getCheckNum,
  getSignature,
  savePrintCheckHistory,
  saveCheckSignature,
  getPrintTimeClockRange,
  getSummaryAppointmentChart,
  getSummarySaleChart,
  getSummaryCategoryChart,
  getSummaryPaymentTypeChart,
  getReportSalaryStaff,
  getReportSalaryStaffV2,
  getConsentFormReport,
  getProductReport,
  getCashDepositReport,
  deleteCashDeposit,
  printMultipleCheck,
  sendReportEmailsCpa,
  getPrintCashDepositByDate,
  getPrintCashDepositById,
  getReportSalaryStaffYearly,
  getHomeReportDiscount,
  getPrintCheckHistory,
  deletePrintCheckHistory,
  updatePrintCheckHistory,
  createSaleAdjustment,
  getListSaleAdjustment,
  deleteSaleAdjustment,
};

export default reportApis;
